// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import apiClient from './client';
import type { Task, TaskSummary, PageResponse } from '../types';

export interface TaskQueryParams {
  status?: string;
  search?: string;
  page?: number;
  size?: number;
  sort?: string;
}

export const getTasks = (params?: TaskQueryParams): Promise<PageResponse<Task>> =>
  apiClient.get<PageResponse<Task>>('/api/tasks', { params }).then((r) => r.data);

export const getTask = (taskId: string): Promise<Task> =>
  apiClient.get<Task>(`/api/tasks/${taskId}`).then((r) => r.data);

export const getTaskSummary = (): Promise<TaskSummary> =>
  apiClient.get<TaskSummary>('/api/tasks/summary').then((r) => r.data);
